import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsersIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1244_8637)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				opacity: .2,
				d: "M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z",
				fill: "#1557b5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z",
				stroke: "#0f172b",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5688 5.42813C14.9998 5.31124 15.4442 5.25136 15.8907 5.25C17.1837 5.25 18.4236 5.76361 19.3379 6.67785C20.2521 7.59209 20.7657 8.83207 20.7657 10.125C20.7657 11.4179 20.2521 12.6579 19.3379 13.5721C18.4236 14.4864 17.1837 15 15.8907 15",
				stroke: "#0f172b",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.5 18.5063C2.2612 17.4231 3.27191 16.539 4.44676 15.9286C5.6216 15.3183 6.92608 14.9997 8.25 14.9997C9.57392 14.9997 10.8784 15.3183 12.0532 15.9286C13.2281 16.539 14.2388 17.4231 15 18.5063",
				stroke: "#0f172b",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.8906 15C17.2147 14.9992 18.5194 15.3174 19.6944 15.9277C20.8693 16.5381 21.8799 17.4225 22.6406 18.5063",
				stroke: "#0f172b",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1244_8637",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgUsersIcon;
